import { render, staticRenderFns } from "./sendMail.vue?vue&type=template&id=06057635&scoped=true&"
import script from "./sendMail.vue?vue&type=script&lang=js&"
export * from "./sendMail.vue?vue&type=script&lang=js&"
import style0 from "./sendMail.vue?vue&type=style&index=0&id=06057635&lang=scss&scoped=true&"
import style1 from "./sendMail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06057635",
  null
  
)

export default component.exports